
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
export default {
  name: 'NoteProgress',
  props: {
    progressList: {
      type: Object,
      default: () => ([
        {
          desc: '上传笔记',
          status: 'done'
        },
        {
          desc: '笔记批改',
          status: 'pendding'
        },
        {
          desc: '未通过',
          status: 'fail'
        },
        {
          desc: '批改完成',
          status: 'todo'
        }
      ])
    },
    status: {
      type: Boolean,
      default: false
    },
    progressText: {
      type: String,
      default: '批改通过，恭喜你升级成3星卡牌'
    },
    currentLevel: {
      type: Number,
      default: 3
    }

  },
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const progressList = computed(() => {
      return props.progressList
    })
    const progressText = computed(() => {
      return props.currentLevel ? `批改通过，恭喜你升级成${props.currentLevel}星卡牌` : props.progressText 
    })

    onMounted(() => {
      // console.log(progressList.value,'progressList')
    })
    return {
      progressList,
      progressText
    };
  },
};
